export default __webpack_public_path__ + "static/media/d8.014e336d.jpg";